// tabId is handy if you ever open multiple dialers per origin.
const TAB_ID_KEY = "taar.tabId";
const CREDS_KEY = (tabId: string) => `taar.dialer.${tabId}.agentCreds`;

function getOrCreateTabId(): string {
  let id = sessionStorage.getItem(TAB_ID_KEY);
  if (!id) {
    id = crypto.randomUUID();
    sessionStorage.setItem(TAB_ID_KEY, id);
  }
  return id;
}

type AgentCreds = { jwt: string; }; // unix seconds

let inMemoryCreds: AgentCreds | null = null;

export function storeCreds(creds: AgentCreds) {
  inMemoryCreds = creds; // primary storage = memory
  const tabId = getOrCreateTabId();
  sessionStorage.setItem(CREDS_KEY(tabId), JSON.stringify(creds)); // reload safety
}

export function loadCreds(): AgentCreds | null {
  if (inMemoryCreds) return inMemoryCreds;
  const tabId = getOrCreateTabId();
  const raw = sessionStorage.getItem(CREDS_KEY(tabId));
  if (!raw) return null;
  try {
    const c = JSON.parse(raw) as AgentCreds;
    // optional TTL check:
    // if (c.exp && c.exp * 1000 < Date.now()) {
    //   clearCreds();
    //   return null;
    // }
    inMemoryCreds = c;
    return c;
  } catch {
    clearCreds();
    return null;
  }
}

export function clearCreds() {
  inMemoryCreds = null;
  const tabId = sessionStorage.getItem(TAB_ID_KEY);
  if (tabId) sessionStorage.removeItem(CREDS_KEY(tabId));
}
